/**
 * env.js — Configurazioni centralizzate dell'applicazione.
 *
 * Per cambiare ambiente imposta IS_LOCAL e IS_TEST:
 *
 *   Produzione   → IS_LOCAL: false, IS_TEST: false
 *   Test remoto  → IS_LOCAL: false, IS_TEST: true
 *   Locale       → IS_LOCAL: true,  IS_TEST: true
 */
const ENV = {

    // ── Flag ambiente ──────────────────────────────────────────
    IS_LOCAL: false,   // true → usa API_URL_LOCAL + porta locale
    IS_TEST:  false,   // true → usa credenziali e chiave Stripe di test

    // ── Flag funzionalità ──────────────────────────────────────
    // true  → Stripe Payment Element (carte + Apple/Google Pay + SEPA + Klarna…)
    // false → Stripe Card Element classico (solo carta di credito/debito)
    USE_STRIPE_PAYMENT_ELEMENT: true,

    // ══════════════════════════════════════════════════════════
    // PRODUZIONE
    // ══════════════════════════════════════════════════════════

    // Backend produzione (define.dart: apiUrl / apiHost / apiPort)
    API_URL:  'https://app.outreachitalia.it',
    API_HOST: 'app.outreachitalia.it',
    API_PORT: 443,

    // Auth guest produzione (define.dart: authPwaIdGuest / authPwaTokenGuest)
    AUTH_ID_GUEST_PROD:    '1',
    AUTH_TOKEN_GUEST_PROD: '822a62f4ae97d50788e148477edc55805823227b2e02196a08d5a930cdae8794',

    // Stripe produzione (main.dart: Stripe.publishableKey live)
    STRIPE_KEY_PROD: 'pk_live_51PDoTEHR1dLI56xH0DfV5EDg8QEoSwujGWD7bYTcWpoUZp7etSq0vLKCe1BcIoP2BMGSb4YP8hjSECHChtSv6Krw00dhLaFzgJ',

    // ══════════════════════════════════════════════════════════
    // TEST / LOCALE  (define.dart: isLOCAL=true / isTEST=true)
    // ══════════════════════════════════════════════════════════

    // Backend locale (define.dart: apiUrlLocal / apiHostLocal / apiPortLocal)
    API_URL_LOCAL:  'https://outreach.client:7373',
    API_HOST_LOCAL: 'outreach.client',
    API_PORT_LOCAL: 7373,

    // Auth guest test — stesse credenziali, ambiente separato
    AUTH_ID_GUEST_TEST:    '1',
    AUTH_TOKEN_GUEST_TEST: '822a62f4ae97d50788e148477edc55805823227b2e02196a08d5a930cdae8794',

    // Stripe test (main.dart: Stripe.publishableKey test — commentato in Flutter)
    STRIPE_KEY_TEST: 'pk_test_51PDoTEHR1dLI56xH0ve4ZvfMNWiurr4g9yKFUlT7XCo6054CpHYlkp8UEtXYEaa0wWV43SQgB1S2dgiHzJigJR5L00KyD4DF6D',

    // Upload token (define.dart: authPwaTokenUpload) — condiviso tra ambienti
    AUTH_TOKEN_UPLOAD: 'v352667oj43207t87234r31280fdthrsdh451238459',

    // ── Dati di test precompilati (define.dart: sharedObjectTest) ─
    // Usati solo con IS_TEST: true per bypassare la compilazione manuale del form
    TEST_BOOKING: {
        reservation_type:  'andata_ritorno_attesa',
        start_date:        '16/12/2026',
        return_date:       '16/12/2026',
        start_time:        '10:15',
        return_time:       '17:15',
        start_address:     'Morena, Rome, Metropolitan City of Rome Capital, Italy',
        start_address_lat: '41.89895200000001',
        start_address_lng: '12.5033626',
        start_address_opts: {
            type:      'Abitazione Privata',
            abit_type: 'piano rialzato',
            ascensore: 'si',
            sedia:     'si',
            sedia_type:'standard (seduta 45cm)',
            barriere:  '',
            jolly:     '',
            note:      '',
            photos:    [],
        },
        end_address:     'Campus Bio Medico University of Rome, Via Álvaro del Portillo, Rome, Metropolitan City of Rome Capital, Italy',
        end_address_lat: '41.8625951',
        end_address_lng: '12.6211888',
        end_address_opts: {
            type:      'Stazioni/Aeroporti/Porti',
            barriere:  'si',
            abit_type: '',
            ascensore: '',
            sedia:     '',
            sedia_type:'',
            jolly:     '',
            note:      '',
            photos:    [],
        },
        seat:       1,
        seat_guest: 1,
        client: {
            name:     'Mario',
            lastname: 'Rossi',
            address:  'Roma Termini, Piazza dei Cinquecento, Roma, Metropolitan City of Rome Capital, Italy',
            cf:       'RSSMRA80A01H501U',
            email:    'dev@sviluppoh.com',
            phone:    '+393333333333',
            privacy:  '1',
        },
        fly_number: '3333trert',
        train_name: '4444tretr',
        boat_name:  '5555gfdgf',
    },

    // ══════════════════════════════════════════════════════════
    // PARAMETRI CONDIVISI
    // ══════════════════════════════════════════════════════════

    // Google Maps (stessa chiave in tutti gli ambienti)
    GOOGLE_API_KEY: 'AIzaSyC5K8cpA9uKLHIi1yGysBCL-jF8bjj8Fgg',

    // Contatti supporto
    CONTACT_PHONE: '+393420304285',
    CONTACT_EMAIL: 'info@outreachitalia.it',
    PRIVACY_URL:   'https://outreachitalia.it/privacy-policy/',

    // Regole di business (define.dart / btn_step_page_widget)
    MIN_BOOKING_HOURS:      24,
    MAX_RETURN_DELTA_H:     24,
    MAX_PASSENGERS_PER_VAN:  8,

    // ══════════════════════════════════════════════════════════
    // GETTER — valori risolti in base ai flag IS_LOCAL / IS_TEST
    // ══════════════════════════════════════════════════════════

    get baseUrl() {
        return this.IS_LOCAL ? this.API_URL_LOCAL : this.API_URL;
    },

    get apiHost() {
        return this.IS_LOCAL ? this.API_HOST_LOCAL : this.API_HOST;
    },

    get apiPort() {
        return this.IS_LOCAL ? this.API_PORT_LOCAL : this.API_PORT;
    },

    get authIdGuest() {
        return this.IS_TEST ? this.AUTH_ID_GUEST_TEST : this.AUTH_ID_GUEST_PROD;
    },

    get authTokenGuest() {
        return this.IS_TEST ? this.AUTH_TOKEN_GUEST_TEST : this.AUTH_TOKEN_GUEST_PROD;
    },

    get stripeKey() {
        return this.IS_TEST ? this.STRIPE_KEY_TEST : this.STRIPE_KEY_PROD;
    },
};
